export const SLICE_NAME_USER = 'factorRequests'
export const FIND_FACTOR_REQUEST = 'findFactorRequest'
export const FIND_FACTOR_REQUEST_SUPPLIER = 'findFactorRequestSupplier'
